import { identity } from '@frontend/duck-tape';
import { createContext } from '@frontend/react';
import type { useGlobalTaskCreation } from '@frontend/react-domain';
import {
  initialTaskCreationState,
  type TaskCreationOptions,
} from '@frontend/react-domain/hooks/useGlobalTaskCreation/helpers';

export type CreateTaskContextType = Pick<
  ReturnType<typeof useGlobalTaskCreation>,
  | 'answers'
  | 'createTaskState'
  | 'decrementStep'
  | 'draftTask'
  | 'incrementStep'
  | 'initialQuestions'
  | 'isOnLastStep'
  | 'isStreaming'
  | 'isSubmitting'
  | 'onUpdateAnswer'
  | 'updateTaskData'
> & {
  closeCreateTaskModal: () => void;
  isCreateTaskModalOpen: boolean;
  openCreateTaskModal: (options: TaskCreationOptions) => void;
};

export const CreateTaskContext = createContext<CreateTaskContextType>({
  answers: [],
  closeCreateTaskModal: identity,
  createTaskState: initialTaskCreationState,
  decrementStep: identity,
  draftTask: null,
  incrementStep: identity,
  initialQuestions: [],
  isCreateTaskModalOpen: false,
  isOnLastStep: false,
  isStreaming: false,
  isSubmitting: false,
  onUpdateAnswer: identity,
  openCreateTaskModal: identity,
  updateTaskData: identity,
});
